module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fveoy"))).then(() => parcelRequire('hEqeo'));